import { CanDeactivateFn } from '@angular/router';

/** A page that can hold unsaved edits: true leaves at once, a promise waits for the user's answer. */
export interface CanLeaveComponent {
  canLeave(): boolean | Promise<boolean>;
}

/**
 * Every way off a page with unsaved edits (a link, the sidebar, the browser's own back button) asks the page first.
 * Typed by the interface, not the page, so the route table does not load the page eagerly. The router passes no page
 * when its outlet never activated one, and then there is nothing to ask about.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanLeaveComponent | null> = page => page?.canLeave() ?? true;
